import { fontFamily, spacing, lightTheme, darkTheme } from '@getgo/chameleon-core';
import { overrides, darkOverrides, lightOverrides, shadows, lightPalette, darkPalette, lightPaletteGh, darkPaletteGh, } from './../';
export const themeBase = {
    shadows,
    typography: {
        fontFamily,
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1440,
        },
    },
    spacing: spacing.map((i) => i * 16),
    zIndex: {
        drawer: 1195,
    },
    props: {
        // Name of the component ⚛️
        MuiButtonBase: {
            // The properties to apply
            disableRipple: true, // No more ripple, on the whole application 💣!
        },
    },
};
const darkThemeBase = Object.assign(Object.assign({}, themeBase), { overrides: Object.assign(Object.assign({}, overrides), darkOverrides) });
const lightThemeBase = Object.assign(Object.assign({}, themeBase), { overrides: Object.assign(Object.assign({}, overrides), lightOverrides) });
const gotoLightTheme = Object.assign(Object.assign({}, lightThemeBase), { palette: lightPalette, tokens: lightTheme });
const gotoDarkTheme = Object.assign(Object.assign({}, darkThemeBase), { palette: darkPalette, tokens: darkTheme });
const grasshopperLightTheme = Object.assign(Object.assign({}, lightThemeBase), { palette: lightPaletteGh, tokens: lightTheme });
const grasshopperDarkTheme = Object.assign(Object.assign({}, darkThemeBase), { palette: darkPaletteGh, tokens: darkTheme });
export const chameleonLightTheme = new Map();
chameleonLightTheme.set('goto', gotoLightTheme);
chameleonLightTheme.set('gotoadmin', gotoLightTheme);
chameleonLightTheme.set('grasshopper', grasshopperLightTheme);
chameleonLightTheme.set('gotoapp', grasshopperLightTheme);
export const chameleonDarkTheme = new Map();
chameleonDarkTheme.set('goto', gotoDarkTheme);
chameleonDarkTheme.set('gotoadmin', gotoDarkTheme);
chameleonDarkTheme.set('grasshopper', grasshopperDarkTheme);
chameleonDarkTheme.set('gotoapp', grasshopperDarkTheme);
